import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { formatDate } from "../../utils/functionCommon";
import { instance } from "../configApi";

const initialState = {
  msg: "",
  isError: false,
  isNotify: false,
  typeNotify: "success",
  isLoading: false,
  callBackRequest: false,
  isOpenModalDetail: false,
  isOpenModalEditDeal: false,
  isOpenModalGetLog: false,
  idDeals: "",
  isOpenModalAddGroupTime: false,
  isOpenModalPostDeals: false,
  callBackRequestGroupTime: false,
  valueDeleteConfig: "",
  dataAreaOne: [],
  detailByID: {},
  dataLog: [],
  data: [],
  total: 0,
  dataGroupTime: [],
  refetchConfig: false,
  config: {
    search: "",
    status: 0,
    typePreferential: -1,
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  },
};
const DealSlice = createSlice({
  name: "deal",
  initialState,
  reducers: {
    resetState: (state) => {
      state.msg = "";
      state.isNotify = false;
      state.typeNotify = "success";
      state.isLoading = false;
      state.callBackRequest = false;
      state.isOpenModalDetail = false;
      state.isOpenModalEditDeal = false;
      state.isOpenModalGetLog = false;
      state.idDeals = "";
      state.isOpenModalAddGroupTime = false;
      state.isOpenModalPostDeals = false;
      state.callBackRequestGroupTime = false;
      state.detailByID = [];
      state.dataLog = [];
      state.data = [];
      state.total = 0;
      state.dataGroupTime = [];
      state.config.search = "";
      state.config.status = 0;
      state.config.typePreferential = -1;
      state.config.option.limit = 10;
      state.config.option.offset = 1;
      state.config.option.order = "desc";
    },
    setSearchText: (state, action) => {
      state.config.option.offset = 1;
      state.config.search = action.payload;
    },
    setPage: (state, action) => {
      state.config.option.offset = action.payload;
    },
    setLimitDeals: (state, action) => {
      state.config.typePreferential = action.payload;
      state.config.option.offset = 1;
    },
    setStatusDeals: (state, action) => {
      state.config.status = action.payload;
      state.config.option.offset = 1;
    },
    setOpenDetailDeals: (state, action) => {
      state.isOpenModalDetail = action.payload.isOpen;
      state.idDeals = action.payload.id;
    },
    setOpenEditDeals: (state, action) => {
      state.isOpenModalEditDeal = action.payload.isOpen;
      state.idDeals = action.payload.id;
    },
    setOpenModalPostDeals: (state, action) => {
      state.isOpenModalPostDeals = action.payload;
    },

    setOpenModalGetLogDeal: (state, action) => {
      state.isOpenModalGetLog = action.payload;
    },
    resetStatus: (state) => {
      state.isLoading = false;
      state.isNotify = false;
      state.msg = "";
      state.typeNotify = "";
    },
    setOpenModalAddGroupTime: (state, action) => {
      state.isOpenModalAddGroupTime = action.payload;
    },
    setMessage: (state, action) => {
      state.isNotify = true;
      state.msg = action.payload.msg;
      state.typeNotify = action.payload.type;
    },
    resetError: (state) => {
      state.isError = false;
      state.msg = "";
    },
    setDataAreaOne: (state, action) => {
      state.dataAreaOne = action.payload;
    },
    setValueDeleteConfig: (state, action) => {
      state.valueDeleteConfig = action.payload;
    },
    setDataDetail: (state, action) => {
      state.detailByID = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //add deals
      .addCase(createDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createDeal.fulfilled, (state, action) => {
        if (action.payload.status === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Thêm bài viết thành công";
          state.callBackRequest = true;
          state.isOpenModalPostDeals = false;
        }
      })
      .addCase(createDeal.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //edit product
      .addCase(editDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editDeal.fulfilled, (state, action) => {
        if (action.payload === 200) {
          state.isNotify = true;
          state.msg = "Sửa thông tin thành công";
          state.callBackRequest = true;
          state.isOpenModalEditDeal = false;
          state.typeNotify = "success";
          state.isLoading = false;
        }
      })
      .addCase(editDeal.rejected, (state) => {
        state.isNotify = true;
        state.typeNotify = "error";
        state.msg = "Sửa thông tin bài viết thất bại";
        state.isLoading = false;
      })

      // get data deals
      .addCase(getAllDeals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllDeals.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.data = action.payload.data;
        state.total = action.payload.total;
        state.callBackRequest = false;
      })
      .addCase(getAllDeals.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // delete deal
      .addCase(deleteDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteDeal.fulfilled, (state, action) => {
        state.isNotify = true;
        state.callBackRequest = true;
        state.msg = "Xóa bài viết thành công";
      })
      .addCase(deleteDeal.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // confirm deal status
      .addCase(confirmdealStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(confirmdealStatus.fulfilled, (state, action) => {
        state.isNotify = true;
        state.callBackRequest = true;
        state.msg = "Cập nhật thành công";
        state.isOpenModalConfirm = false;
      })
      .addCase(confirmdealStatus.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // get data detail product
      .addCase(getDetailDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDetailDeal.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.detailByID = {
          ...action.payload,
          time: formatDate(action.payload.timeCreate),
        };
      })
      .addCase(getDetailDeal.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //get time group
      .addCase(getGroupTime.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGroupTime.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.dataGroupTime = action.payload;
        state.callBackRequestGroupTime = false;
      })
      .addCase(getGroupTime.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //add time group
      .addCase(createGroupTime.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createGroupTime.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;
          return;
        }
        state.isNotify = true;
        state.msg = "Thêm nhóm thành công";
        state.isError = false;
        state.callBackRequestGroupTime = true;
        state.isOpenModalAddGroupTime = false;
      })
      .addCase(createGroupTime.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //delete time group
      .addCase(deleteGroupTime.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteGroupTime.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.status) {
          state.isError = true;
          state.msg = action.payload.message;

          return;
        }
        state.isNotify = true;
        state.msg = "Xóa nhóm thành công";
        state.callBackRequestGroupTime = true;
        state.isOpenModalAddGroupTime = false;
      })
      .addCase(deleteGroupTime.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // get log
      .addCase(getLogDeal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogDeal.fulfilled, (state, action) => {
        state.dataLog = action.payload;
        state.isOpenModalGetLog = true;
        state.isLoading = false;
      })
      .addCase(getLogDeal.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // get data area
      .addCase(getDataArea.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDataArea.fulfilled, (state, action) => {
        state.dataAreaOne = action.payload;
        state.isLoading = false;
        state.refetchConfig = false;
      })
      .addCase(getDataArea.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // post data area
      .addCase(postPin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postPin.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          state.isNotify = true;
          state.typeNotify = "success";
          state.msg = "Thêm vào danh sách slider thành công";
          state.refetchConfig = true;
          state.isLoading = false;
        }
        if (action.payload.status === 0) {
          state.isNotify = true;
          state.typeNotify = "error";
          state.msg = "Danh sách slider đã có bài viết";
          state.refetchConfig = true;
          state.isLoading = false;
          state.isLoading = false;
        }
      })
      .addCase(postPin.rejected, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // delete item data area
      .addCase(deleteItemPin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteItemPin.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.status === 1) {
          state.isNotify = true;
          state.msg = "Xóa bài ghim thành công";
          state.refetchConfig = true;
        } else {
          state.isLoading = false;
        }
      })
      .addCase(deleteItemPin.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // update pin
      .addCase(updatePin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePin.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          state.isNotify = true;
          state.msg = "Lưu thiết lập thành công";
          state.refetchConfig = true;
          state.isLoading = false;
        }
      })
      .addCase(updatePin.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      });
  },
});
export default DealSlice;

export const {
  setCategoryId,
  setStatusProduct,
  setOpenEditDeals,
  setOpenModalPostDeals,
  setOpenDetailDeals,
  resetStatus,
  setPage,
  setSearchText,
  setLimitDeals,
  setStatusDeals,
  setOpenDetailNews,
  setOpenModalAddProduct,
  setOpenModalGetLogDeal,
  setMessage,
  setOpenModalAddGroupTime,
  resetState,
  resetError,
  setDataAreaOne,
  setValueDeleteConfig,
  setDataDetail,
} = DealSlice.actions;

//create deal
export const createDeal = createAsyncThunk("deal/createDeal", async (data) => {
  try {
    const res = await instance.post(
      "/preferentialPost/createPreferentialPost",
      data,
      {
        headers: {
          "Content-type": "multipart/form-date",
        },
      }
    );
    return res;
  } catch (error) {
    console.log(error);
    return error.reponse.data;
  }
});
//edit
export const editDeal = createAsyncThunk("deal/editDeal", async (data) => {
  try {
    const res = await instance.put(
      "/preferentialPost/editPreferentialPost",
      data,
      {
        headers: {
          "Content-type": "multipart/form-date",
        },
      }
    );
    return res.status;
  } catch (error) {
    console.log(error);
    return error.reponse.data;
  }
});
// delete
export const deleteDeal = createAsyncThunk("deal/deleteDeal", async (id) => {
  try {
    const res = await instance.delete(
      `/preferentialPost/deletePreferentialPost/${id}`
    );
    return res.status;
  } catch (error) {
    console.log(error);
    return error.reponse.data;
  }
});

export const confirmdealStatus = createAsyncThunk(
  "deal/confirmdealStaus",
  async (data) => {
    try {
      const res = await instance.put(`/product/changeStatusProduct`, data);
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
//get data
export const getAllDeals = createAsyncThunk(
  "deal/getAllDeals",
  async (options) => {
    try {
      const config = options
        ? options
        : {
            search: "",
            typePreferential: -1,
            status: 0,
            option: {
              limit: 10,
              offset: 1,
              order: "desc",
            },
          };
      const res = await instance.post("/preferentialPost/pageable", config);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
//detail
export const getDetailDeal = createAsyncThunk(
  "deal/getDetailDeal",
  async (id) => {
    try {
      const res = await instance.get(`/preferentialPost/getDetail/${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);

// get time group
export const getGroupTime = createAsyncThunk("deal/getGroupTime", async () => {
  try {
    const res = await instance.get(`/attractGroup/getAll`);
    const result = res.data;
    return result.data;
  } catch (error) {
    console.log(error);
  }
});
// add time group
export const createGroupTime = createAsyncThunk(
  "deal/createGroupTime",
  async (data) => {
    try {
      const res = await instance.post(`/attractGroup/createAttractGroup`, data);
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//delete time group
export const deleteGroupTime = createAsyncThunk(
  "deal/deleteGroupTime",
  async (id) => {
    try {
      const res = await instance.delete(
        `/attractGroup/deleteAttractGroup/${Number(id)}`
      );
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
      return error.response.data;
    }
  }
);
//get log
export const getLogDeal = createAsyncThunk("deal/getLog", async (id) => {
  try {
    const res = await instance.get(`/preferentialPostLog/getLog/${id}`);
    const result = res.data;
    return result.data;
  } catch (error) {
    console.log(error);
  }
});
// get pin
export const getDataArea = createAsyncThunk("deal/getDataArea", async () => {
  try {
    const res = await instance.get(`/preferentialPostPin/getPin`);
    const result = res.data;
    return result.data;
  } catch (error) {
    console.log(error);
  }
});
// post  pin
export const postPin = createAsyncThunk("deal/postPin", async (data) => {
  try {
    const res = await instance.post("/preferentialPostPin/pin", data, {
      headers: {
        "Content-type": "multipart/form-date",
      },
    });
    return res.data;
  } catch (error) {
    return error.response.data;
  }
});

//delete item pin
export const deleteItemPin = createAsyncThunk(
  "deal/deleteItemPin",
  async (data) => {
    try {
      const res = await instance.post("/preferentialPostPin/deletePin", data);
      return res.data;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
// update pin
export const updatePin = createAsyncThunk("deal/updatePin", async (data) => {
  try {
    const res = await instance.post("/preferentialPostPin/updatePin", data);
    return res.data;
  } catch (error) {
    console.log(error);
    return error.reponse.data;
  }
});
